import React from 'react';

function CartPage() {
  return (
    <div>
      <h1>Cart Page</h1>
    </div>
  );
}

export default CartPage;
